



















































import { defineComponent, Ref, ref, watch } from '@vue/composition-api';
import {
  APrimaryBtn,
  ASecondaryBtn
} from '../../../../customer/components/src/lib/components/base/app/buttons';

export default defineComponent({
  name: 'RequestInfoDialog',
  components: {
    APrimaryBtn,
    ASecondaryBtn
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    inputText: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: 'cancel'
    },
    width: {
      type: String,
      default: '400px'
    },
    information: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit, root }) {
    const info = ref(props.inputText);
    watch(
      () => props.inputText,
      (newVal) => {
        info.value = newVal;
      }
    );

    const closeDialog = () => {
      info.value = '';
      emit('input', false);
    };
    const confirm = () => {
      form.value.validate().then((valid) => {
        if (valid) {
          emit('confirm', info.value);
          closeDialog();
        }
      });
    };

    const form: Ref<any> = ref();

    const emptyRule = [
      (value: any) => !!value || root.$t('check_documents.reject_message')
    ];

    return { closeDialog, confirm, info, form, emptyRule };
  }
});
